import { render, staticRenderFns } from "./AttrList.vue?vue&type=template&id=048e0d46&scoped=true"
import script from "./AttrList.vue?vue&type=script&lang=ts"
export * from "./AttrList.vue?vue&type=script&lang=ts"
import style0 from "./AttrList.vue?vue&type=style&index=0&id=048e0d46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048e0d46",
  null
  
)

export default component.exports